module.exports = __webpack_public_path__ + "img/2-8.495a180a.png";